import Vue from 'vue'

const state = {

}

const getters = {
  activeBlock: state => state.activeBlock,
  activeItem: state => state.activeItem
}

const actions = {
  setActiveBlock ({ commit }, payload) {
    commit(`SAVE_ACTIVE_BLOCK_TO_STATE`, payload)
  },

  setActiveItem ({ commit }, payload) {
    commit(`SAVE_ACTIVE_ITEM_TO_STATE`, payload)
  },

  setActiveChapter ({ commit }, payload) {
    commit('SAVE_ACTIVE_CHAPTER', payload)
  }
}

const mutations = {
  SAVE_ACTIVE_BLOCK_TO_STATE (state, payload) {
    Vue.set(state, `activeBlock`, payload)
  },

  SAVE_ACTIVE_ITEM_TO_STATE (state, payload) {
    Vue.set(state, `activeItem`, payload)
  }
}

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
